// ImageStylePicker.tsx — widget del step 'style'.
// Qué hace: grilla de fuentes de imagen (solid / stock / my photos / mix / AI /
//   AI-styled posters) con locks por plan; al estar locked lleva a billing.
// Qué exporta: ImageStylePicker.
// Quién lo usa: NovahGenerateChat.

import { ImageStyle, UserPlan } from '../types';
import { WidgetWrap, StyleGrid, StyleOption, StyleIcon, StyleLabel, PlanTag, LockBadge } from '../styled';

interface Props {
  userPlan: UserPlan;
  hasBackgroundImages: boolean;
  confirmStyle: (style: ImageStyle) => void;
  onNavigateBilling: () => void;
}

export function ImageStylePicker({ userPlan, hasBackgroundImages, confirmStyle, onNavigateBilling }: Props) {
  return (
    <WidgetWrap>
      <StyleGrid>
        {/* Solid colors — Free+ */}
        <StyleOption $active={false} onClick={() => confirmStyle('pastel')}>
          <StyleIcon>🎨</StyleIcon><StyleLabel>Solid colors</StyleLabel>
          <PlanTag>Free</PlanTag>
        </StyleOption>

        {/* Stock photos — Pro+ */}
        <StyleOption
          $active={false}
          $locked={userPlan === 'free'}
          onClick={() => userPlan === 'free' ? onNavigateBilling() : confirmStyle('stock')}
        >
          {userPlan === 'free' && <LockBadge>🔒</LockBadge>}
          <StyleIcon>📷</StyleIcon><StyleLabel>Stock photos</StyleLabel>
          <PlanTag>Pro</PlanTag>
        </StyleOption>

        {/* My photos — Business only */}
        {hasBackgroundImages && (
          <StyleOption
            $active={false}
            $locked={userPlan !== 'business'}
            onClick={() => userPlan !== 'business' ? onNavigateBilling() : confirmStyle('asset')}
          >
            {userPlan !== 'business' && <LockBadge>🔒</LockBadge>}
            <StyleIcon>🖼️</StyleIcon><StyleLabel>My photos</StyleLabel>
            <PlanTag>Business</PlanTag>
          </StyleOption>
        )}

        {/* Mix it up — Pro+ */}
        <StyleOption
          $active={false}
          $locked={userPlan === 'free'}
          onClick={() => userPlan === 'free' ? onNavigateBilling() : confirmStyle('mix')}
        >
          {userPlan === 'free' && <LockBadge>🔒</LockBadge>}
          <StyleIcon>✨</StyleIcon><StyleLabel>Mix it up</StyleLabel>
          <PlanTag>Pro</PlanTag>
        </StyleOption>

        {/* AI Generated — Business only */}
        <StyleOption
          $active={false}
          $locked={userPlan !== 'business'}
          onClick={() => userPlan !== 'business' ? onNavigateBilling() : confirmStyle('ai')}
        >
          {userPlan !== 'business' && <LockBadge>🔒</LockBadge>}
          <StyleIcon>🤖</StyleIcon><StyleLabel>AI Generated</StyleLabel>
          <PlanTag>Business</PlanTag>
        </StyleOption>

        {/* AI-styled posters — full IA con texto baked. Business only */}
        <StyleOption
          $active={false}
          $locked={userPlan !== 'business'}
          onClick={() => userPlan !== 'business' ? onNavigateBilling() : confirmStyle('styled')}
        >
          {userPlan !== 'business' && <LockBadge>🔒</LockBadge>}
          <StyleIcon>🎭</StyleIcon><StyleLabel>AI-styled posters</StyleLabel>
          <PlanTag>Business</PlanTag>
        </StyleOption>

        {/* AI Transfer — combina un anuncio de referencia + tu foto + tu logo. Business only */}
        <StyleOption
          $active={false}
          $locked={userPlan !== 'business'}
          onClick={() => userPlan !== 'business' ? onNavigateBilling() : confirmStyle('transfer')}
        >
          {userPlan !== 'business' && <LockBadge>🔒</LockBadge>}
          <StyleIcon>🔀</StyleIcon><StyleLabel>AI Transfer</StyleLabel>
          <PlanTag>Business</PlanTag>
        </StyleOption>
      </StyleGrid>
    </WidgetWrap>
  );
}
